"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j;
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnowledgeController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const platform_express_1 = require("@nestjs/platform-express");
const knowledge_service_1 = require("./knowledge.service");
const create_knowledge_file_dto_1 = require("./dto/create-knowledge-file.dto");
const create_knowledge_url_dto_1 = require("./dto/create-knowledge-url.dto");
const update_knowledge_dto_1 = require("./dto/update-knowledge.dto");
let KnowledgeController = class KnowledgeController {
    constructor(service) {
        this.service = service;
    }
    async uploadFile(file, dto, req) {
        const userId = parseInt(req?.headers?.userid);
        return await this.service.createFile(file, dto, userId);
    }
    createUrl(dto, req) {
        const userId = parseInt(req?.headers?.userid);
        return this.service.createUrl(dto, userId);
    }
    async replaceFile(file, documentId, dto, req) {
        const userId = parseInt(req?.headers?.userid);
        return await this.service.replaceFile(documentId, file, userId, dto);
    }
    replaceUrl(documentId, url, dto, req) {
        const userId = parseInt(req?.headers?.userid);
        return this.service.replaceUrl(+documentId, url, userId, dto);
    }
    async updateMeta(documentId, dto, req) {
        const userId = parseInt(req?.headers?.userid);
        return await this.service.updateMetadata(documentId, dto, userId);
    }
    async remove(documentId, req) {
        const userId = parseInt(req?.headers?.userid);
        return await this.service.delete(documentId, userId);
    }
    list(categoryId, page = '1', limit = '10') {
        return this.service.list(categoryId ? +categoryId : undefined, +page, +limit);
    }
    listCatalog(start = '0', limit = '10') {
        return this.service.listForAllCategories(+start, +limit);
    }
    async download(documentId, res) {
        try {
            const result = await this.service.download(documentId);
            // Set headers for download
            res.setHeader('Content-Disposition', `attachment; filename="${result.fileName}"`);
            res.setHeader('Content-Type', result.mimeType || 'application/octet-stream');
            if (result.contentLength) {
                res.setHeader('Content-Length', result.contentLength);
            }
            res.setHeader('Access-Control-Expose-Headers', 'Content-Disposition');
            // Pipe the stream to the response
            result.stream.pipe(res);
        }
        catch (error) {
            if (error instanceof common_1.BadRequestException || error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.BadRequestException('Failed to download document');
        }
    }
    async incrementAccess(documentId) {
        return await this.service.incrementAccess(documentId);
    }
};
exports.KnowledgeController = KnowledgeController;
tslib_1.__decorate([
    (0, common_1.Post)('file'),
    (0, common_1.UseInterceptors)((0, platform_express_1.FileInterceptor)('file')),
    tslib_1.__param(0, (0, common_1.UploadedFile)()),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_c = typeof Express !== "undefined" && (_b = Express.Multer) !== void 0 && _b.File) === "function" ? _c : Object, typeof (_d = typeof create_knowledge_file_dto_1.CreateKnowledgeFileDto !== "undefined" && create_knowledge_file_dto_1.CreateKnowledgeFileDto) === "function" ? _d : Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], KnowledgeController.prototype, "uploadFile", null);
tslib_1.__decorate([
    (0, common_1.Post)('url'),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_e = typeof create_knowledge_url_dto_1.CreateKnowledgeUrlDto !== "undefined" && create_knowledge_url_dto_1.CreateKnowledgeUrlDto) === "function" ? _e : Object, Object]),
    tslib_1.__metadata("design:returntype", void 0)
], KnowledgeController.prototype, "createUrl", null);
tslib_1.__decorate([
    (0, common_1.Put)('file/:documentId'),
    (0, common_1.UseInterceptors)((0, platform_express_1.FileInterceptor)('file')),
    tslib_1.__param(0, (0, common_1.UploadedFile)()),
    tslib_1.__param(1, (0, common_1.Param)('documentId')),
    tslib_1.__param(2, (0, common_1.Body)()),
    tslib_1.__param(3, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_g = typeof Express !== "undefined" && (_f = Express.Multer) !== void 0 && _f.File) === "function" ? _g : Object, BigInt, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], KnowledgeController.prototype, "replaceFile", null);
tslib_1.__decorate([
    (0, common_1.Put)(':documentId/url'),
    tslib_1.__param(0, (0, common_1.Body)('documentId')),
    tslib_1.__param(1, (0, common_1.Body)('url')),
    tslib_1.__param(2, (0, common_1.Body)()),
    tslib_1.__param(3, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [BigInt, String, typeof (_h = typeof update_knowledge_dto_1.UpdateKnowledgeDto !== "undefined" && update_knowledge_dto_1.UpdateKnowledgeDto) === "function" ? _h : Object, Object]),
    tslib_1.__metadata("design:returntype", void 0)
], KnowledgeController.prototype, "replaceUrl", null);
tslib_1.__decorate([
    (0, common_1.Put)(':documentId'),
    tslib_1.__param(0, (0, common_1.Body)('documentId')),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [BigInt, typeof (_j = typeof update_knowledge_dto_1.UpdateKnowledgeDto !== "undefined" && update_knowledge_dto_1.UpdateKnowledgeDto) === "function" ? _j : Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], KnowledgeController.prototype, "updateMeta", null);
tslib_1.__decorate([
    (0, common_1.Delete)(':documentId'),
    tslib_1.__param(0, (0, common_1.Param)('documentId')),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [BigInt, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], KnowledgeController.prototype, "remove", null);
tslib_1.__decorate([
    (0, common_1.Get)(),
    tslib_1.__param(0, (0, common_1.Query)('categoryId')),
    tslib_1.__param(1, (0, common_1.Query)('page')),
    tslib_1.__param(2, (0, common_1.Query)('limit')),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object, Object]),
    tslib_1.__metadata("design:returntype", void 0)
], KnowledgeController.prototype, "list", null);
tslib_1.__decorate([
    (0, common_1.Get)('catalog'),
    tslib_1.__param(0, (0, common_1.Query)('start')),
    tslib_1.__param(1, (0, common_1.Query)('limit')),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, Object]),
    tslib_1.__metadata("design:returntype", void 0)
], KnowledgeController.prototype, "listCatalog", null);
tslib_1.__decorate([
    (0, common_1.Get)(':documentId/download'),
    tslib_1.__param(0, (0, common_1.Param)('documentId')),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [BigInt, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], KnowledgeController.prototype, "download", null);
tslib_1.__decorate([
    (0, common_1.Post)(':documentId/access'),
    tslib_1.__param(0, (0, common_1.Param)('documentId')),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", Promise)
], KnowledgeController.prototype, "incrementAccess", null);
exports.KnowledgeController = KnowledgeController = tslib_1.__decorate([
    (0, common_1.Controller)('knowledge'),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof knowledge_service_1.KnowledgeService !== "undefined" && knowledge_service_1.KnowledgeService) === "function" ? _a : Object])
], KnowledgeController);
